import { HttpV1 as HTTP } from '@/request';

// 查询我的保证金
export async function userDeposit(id) {
    return await HTTP.get(`/agent/user/margin`, { id: id });
}
